import { render, staticRenderFns } from "./EventV2.vue?vue&type=template&id=7be016a6&scoped=true&"
import script from "./EventV2.vue?vue&type=script&lang=js&"
export * from "./EventV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be016a6",
  null
  
)

export default component.exports